export default "__VITE_ASSET__Cp1p7j_1__"